import axios from 'axios';
import { getActiveToken } from '../utils/authStorage';

const API = axios.create({
  baseURL: process.env.REACT_APP_API_URL ? `${process.env.REACT_APP_API_URL}/api` : '/api',
});

// Auto-attach JWT token to every request
API.interceptors.request.use((req) => {
  const token = getActiveToken();
  if (token) {
    req.headers.Authorization = `Bearer ${token}`;
  }
  return req;
});

export default API;
